export const CONTACT = {
  hotline: "1300 85 95 77",
  hotlineHref: "tel:1300859577",
  office: "Levels 14 & 15, 37 Monaco St, Broadbeach Waters QLD 4217",
  web: "carwashsolar.com.au",
  parentWeb: "solaradvisers.com.au",
  people: [
    {
      id: "mark",
      name: "Mark Sutton",
      role: "Managing Director",
      phone: "0418 197 535",
      href: "tel:0418197535",
      email: "mark@solaradvisers.com.au",
      bio: "With over 41 years in self-funded business solutions, and the national solar adviser to Business Associations, Chambers of Commerce and hundreds of businesses, Mark's committed to carwash energy solutions funded entirely by the savings delivered — with no upfront costs at all.",
    },
    {
      id: "stephen",
      name: "Stephen Harley",
      role: "National Sales Director",
      phone: "0438 55 2528",
      href: "tel:0438552528",
      email: "stephen@solaradvisers.com.au",
      bio: "Steve leads our national sales team — call him 24/7 to talk through your site, your power bills and the issues holding you back, and how to solve them for good, easily and simply.",
    },
  ],
};

export const NAV_LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/solutions", label: "Solutions", id: "solutions" },
  { to: "/batteries", label: "Batteries", id: "batteries" },
  { to: "/savings", label: "Savings", id: "calculator" },
  { to: "/13-questions", label: "13 Questions", id: "guide" },
  { to: "/about", label: "About", id: "about" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export const IMG = {
  heroWash: "/images/hero-wash.jpg",
  washSuds: "/images/wash-suds.jpg",
  washSpray: "/images/wash-spray.jpg",
  solarSunset: "/images/solar-sunset.jpg",
  solarAerial: "/images/solar-aerial.jpg",
  installer: "/images/installer.jpg",
  battery: "/images/battery.jpg",
};

export const MARQUEE = [
  "Up to $70,000 per meter in rebates",
  "Zero capital outlay",
  "$1.8M saved over 25 years",
  "2 – 2.5 year payback",
  "Lowest price guarantee",
  "Monitored 24/7",
];

export const REGIONS = [
  { name: "Greater Brisbane & Brisbane West", state: "QLD" },
  { name: "Noosa, Sunshine Coast & Hinterland", state: "QLD", team: "Noosa Solar + Batteries Advisers" },
  { name: "Cooloola to Gladstone", state: "QLD", team: "Wide Bay Solar + Batteries Advisers" },
  { name: "Grafton to Forster", state: "NSW", team: "Mid Coast Solar + Batteries Advisers" },
  { name: "Greater Sydney & NSW", state: "NSW" },
  { name: "Greater Melbourne, Victoria & Tasmania", state: "VIC / TAS" },
  { name: "Greater Adelaide & South Australia", state: "SA" },
  { name: "Greater Perth & Western Australia", state: "WA" },
  { name: "Darwin & Northern Territory", state: "NT" },
];

export const STEPS = [
  { n: "01", title: "Assess", text: "A coffee at your carwash or a Zoom call. We look at your site, your roof and your power bills — a clear, honest talk about what's actually possible." },
  { n: "02", title: "Design", text: "Solar, batteries, or an add-on to your current system — sized to your wash. Most carwashes take up to 100kW without special engineering or energy redesigns." },
  { n: "03", title: "Install", text: "Our operational, engineering and installation teams are on the ground in every state, wherever your carwash is." },
  { n: "04", title: "Monitor", text: "Your system joins 1000's monitored 24/7 by 766+ CEC-verified engineers." },
  { n: "05", title: "Maintain", text: "Ongoing maintenance around the clock — and in many cases, we can even fix issues remotely." },
];

export const STATES = ["QLD", "NSW", "VIC", "TAS", "SA", "WA", "NT", "ACT"];
